import { createSelector } from "@ngrx/store";
import { selectDataState } from "../../data.selectors";

// **************************************************************************
// COUNTRIES SELECTORS
// **************************************************************************
export const selectCountryState = createSelector(selectDataState, state => state.country);
export const selectCountry = createSelector(selectCountryState, state => state.currentCountry);
export const selectCountryLoading = createSelector(selectCountryState, state => state.countryLoading);
export const selectCountryProjectManagement = createSelector(selectCountry, country => country?.countryProjectManagement ?? null);
